export default __webpack_public_path__ + "static/media/image5.55492ae8.svg";